<template>
  <span v-if="show" class="lease-status-tag" :class="'is-' + tagType">{{
    label
  }}</span>
  <span v-else class="lease-status-empty">{{ emptyText }}</span>
</template>

<script>
import { enumLabel, statusTagType } from "@/service/fishPondLeaseEnums.js";

/**
 * 鱼塘租赁状态彩色标签（对齐源系统 el-tag 样式）
 * 使用自绘样式，不依赖项目是否按需注册 Element Tag。
 * kind: audit | property | tenant | contract | payment
 */
export default {
  name: "LeaseStatusTag",
  props: {
    kind: { type: String, required: true },
    value: { type: [Number, String], default: null },
    enumName: { type: String, default: "" },
    emptyText: { type: String, default: "--" },
    hideEmpty: { type: Boolean, default: false }
  },
  computed: {
    show: function() {
      if (this.hideEmpty && (this.value == null || this.value === "")) {
        return false;
      }
      return this.value != null && this.value !== "";
    },
    tagType: function() {
      return statusTagType(this.kind, this.value) || "info";
    },
    label: function() {
      var name = this.enumName || this.defaultEnumName;
      return enumLabel(name, this.value);
    },
    defaultEnumName: function() {
      var map = {
        audit: "auditStatus",
        property: "propertyStatus",
        tenant: "tenantStatus",
        contract: "contractStatus",
        payment: "paymentStatus"
      };
      return map[this.kind] || "";
    }
  }
};
</script>

<style scoped>
.lease-status-tag {
  display: inline-block;
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-sizing: border-box;
  white-space: nowrap;
  vertical-align: middle;
}

.lease-status-tag.is-success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}

.lease-status-tag.is-warning {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
}

.lease-status-tag.is-danger {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
}

.lease-status-tag.is-info {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
}

.lease-status-empty {
  color: #909399;
}
</style>
